var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayersLeftNavigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0L0 11L11 22L13 20L4 11L13 2L11 0Z",
    fill: "#F7A246"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayersLeftNavigation);
export default __webpack_public_path__ + "static/media/LayersLeftNavigation.c3da7f9b904f57fdc826ef9fa57244e7.svg";
export { ForwardRef as ReactComponent };